import { Inline, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import type { CheckedBaggageSummary } from '@eti/schema-types';
import { CheckCircle } from '@phosphor-icons/react';
import { getIncludedBaggageText } from './utils/getIncludedBaggageText';
import isCheckedBaggageIncluded from './utils/isCheckedBaggageIncluded';
import { iconStyles } from './CabinBaggageFeature';

const featureTextStyles = css`
  width: -webkit-fill-available; /* stylelint-disable */
`;

interface CheckedBaggageFeatureProps {
  checkedBaggageSummary: CheckedBaggageSummary;
}

const CheckedBaggageFeature = ({ checkedBaggageSummary }: CheckedBaggageFeatureProps) => {
  const { t } = useTranslation();
  if (!isCheckedBaggageIncluded(checkedBaggageSummary, t)) {
    return null;
  }

  const { tripSummaries } = checkedBaggageSummary;
  const checkedInBaggageName =
    tripSummaries &&
    tripSummaries[0] &&
    getIncludedBaggageText(
      tripSummaries[0].baggageDetails,
      'IbeClient.CheckInBaggageIncluded.Label',
      t,
    );
  if (!checkedInBaggageName) {
    return null;
  }
  return (
    <Inline as="li" noWrap role="listitem" spacing={8}>
      <CheckCircle
        className={iconStyles}
        color={vars.colors.signal.positive.foreground}
        size={20}
        weight="fill"
      />
      <Text as="p" className={featureTextStyles}>
        {checkedInBaggageName}
      </Text>
    </Inline>
  );
};

export default CheckedBaggageFeature;
